export const BASE_URL = "https://safe-expert-airedale.ngrok-free.app";
export const END_GET_APPLICATION_PROPERTIES = "/web/application/properties/version";
export const END_GET_AUTH_LOGIN = '/web/auth';
export const END_GET_AUTH_SIGNUP = '/web/signup';
export const GET_DAILY_RSS_BOOK_DATA = '/app/rss/book/daily'
export const END_GET_AUTH_LOGOUT =  '/web/logout';
export const IMAGE_BLOB_DATA_URL = '/app/blob/image/asset/';
export const ZIP_BLOB_DATA_URL =  '/app/blob/zip/asset/';
export const EPUB_BLOB_DATA_URL =  '/app/blob/epub/asset/';
export const EPUB_BYTE_DATA_URL =  '/app/byte/epub/asset/';

export const NAVBAR_SEARCH_API =  '/app/web/global/search/';
export const FETCH_BOOKS_BY_PAGE = '/app/web/books/fetch/all/';
export const FETCH_EPUB_DATA =  '/app/read';
export const CHECK_IF_USER_IS_VALID = '/web/user/check/'



